import { useGetAccountLocale } from "@/hooks/useGetAccountLocale";
import { formatTimeAgo } from "@/lib/utils";
import { MonitorIcon } from "lucide-react";

export default function LastSeenBadge({
  lastActive,
}: {
  lastActive: string | null;
}) {
  const locale = useGetAccountLocale();

  return (
    <div className="flex flex-row text-sm gap-2 rounded-full bg-[#3D4639] px-4 py-1.5 items-center shadow-[inset_0_2px_3px_rgba(0,0,0,0.5)]">
      <MonitorIcon className="h-5 w-5 stroke-white" />
      {formatTimeAgo(lastActive, locale.code)}
    </div>
  );
}
